import axios, { AxiosResponse } from 'axios'
import {
  DocumentoPessoa,
  DocumentoPessoaDtoCreate,
  DocumentoPessoaDtoUpdate,
  DocumentosPessoaRequests,
} from './_models'

/** Monta as quatro chamadas do sub-recurso `documento` de um dono (`funcionarios` ou `pacientes`). */
export const criarRequestsDocumentos = (baseUrl: string): DocumentosPessoaRequests => ({
  listar: (ownerId: number) =>
    axios
      .get(`${baseUrl}/documento/${ownerId}`)
      .then((r: AxiosResponse<DocumentoPessoa[]>) => r.data),
  criar: (ownerId: number, dto: DocumentoPessoaDtoCreate) =>
    axios
      .post(`${baseUrl}/documento/${ownerId}`, dto)
      .then((r: AxiosResponse<DocumentoPessoa>) => r.data),
  atualizar: (ownerId: number, idDocumento: number, dto: DocumentoPessoaDtoUpdate) =>
    axios
      .put(`${baseUrl}/documento/${ownerId}/${idDocumento}`, dto)
      .then((r: AxiosResponse<DocumentoPessoa>) => r.data),
  excluir: (ownerId: number, idDocumento: number) =>
    axios.delete(`${baseUrl}/documento/${ownerId}/${idDocumento}`).then(() => undefined),
})
